var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word",attrs:{"id":"back"},on:{"click":_vm.backFn}},[_c('img',{staticClass:"back-img",attrs:{"src":require("@/assets/images/back.png"),"alt":""}}),_vm._v("\n    "+_vm._s(_vm.$t('header.returns'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72a42b08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/assembly/Back.vue
// module id = null
// module chunks = 